import { createAction } from 'redux-actions'

const ns = 'loading/'

export const setLoadingJoinGoal = createAction(`${ns}SET_JOIN_GOAL`)
export const setLoadingJoinGoalDone = createAction(`${ns}SET_JOIN_GOAL_DONE`)
